import { Paper } from '@mui/material';
import useWindowsDimension from 'functions/useWindowsDimension';
import { FC } from 'react';

/**
 * Component to display history of ticket products and ticket actions side by side.
 */
export const TicketResolution: FC = () => {
  const { height } = useWindowsDimension();

  return (
    <Paper
      variant='elevation3'
      sx={{
        width: '50%',
        height: Math.ceil(height - 122),
        ml: 2,
        backgroundColor: 'primary.main',
      }}
    >
      TicketResolution
    </Paper>
  );
};
